import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { beginGoogle } from "@/googleAuth";

export default function GoogleSignIn({ studioSlug = "", registration = false, "data-testid": testId }) {
  useUiLanguage();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const incomingError = new URLSearchParams(window.location.search).has("google_error");
  return <div className="my-4 space-y-2">
    <Button data-testid={testId} type="button" variant="outline" className="min-h-12 w-full border-white/20" disabled={busy} onClick={async () => {
      setBusy(true); setError("");
      try { await beginGoogle(studioSlug); }
      catch { setError(tr("Impossibile avviare Google. Consenti la memorizzazione nel browser e riprova.")); setBusy(false); }
    }}>{busy ? tr("Apertura Google…") : registration ? tr("Registrati con Google") : tr("Accedi con Google")}</Button>
    {(error || incomingError) && <p role="alert" className="text-sm text-red-300">{error || tr("Accesso Google non completato. Riprova oppure usa email e password.")}</p>}
  </div>;
}
